import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-wifinone",
  "use": "icon-th-wifinone-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-wifinone\">\n<path d=\"M17.5 25.5C17.5 25.7967 17.412 26.0867 17.2472 26.3334C17.0824 26.58 16.8481 26.7723 16.574 26.8858C16.2999 26.9993 15.9983 27.0291 15.7074 26.9712C15.4164 26.9133 15.1491 26.7704 14.9393 26.5607C14.7296 26.3509 14.5867 26.0836 14.5288 25.7926C14.4709 25.5017 14.5006 25.2001 14.6142 24.926C14.7277 24.6519 14.92 24.4176 15.1666 24.2528C15.4133 24.088 15.7033 24 16 24C16.3978 24 16.7794 24.158 17.0607 24.4393C17.342 24.7206 17.5 25.1022 17.5 25.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-wifinone.svg
// module id = lbZA
// module chunks = 84